import { Button, FormField, Input, Switch, ControlRow } from '@vd/ui';
import styles from '../Settings.module.css';
import { useState } from 'react';

export function ArchivalTab() {
  const [enabled, setEnabled] = useState(true);
  const [days, setDays] = useState(90);

  return (
    <>
      <h1 className={styles.h1}>Archival</h1>
      <p className={styles.sub}>Tickets are archived after a period of inactivity. Columns can override.</p>

      <section className={styles.section}>
        <ControlRow>
          <Switch checked={enabled} onChange={(e) => setEnabled(e.target.checked)} />
          <span>Archive tickets automatically</span>
        </ControlRow>
        <div style={{ height: 12 }} />
        {enabled && (
          <FormField label="Days of inactivity before archive" help="Columns can override this per-column.">
            <Input type="number" value={days} onChange={(e) => setDays(Number(e.target.value))} min={1} max={365 * 5} />
          </FormField>
        )}
        <div style={{ height: 12 }} />
        <Button variant="primary">Save</Button>
      </section>
    </>
  );
}
